import './style.css'

import Game from './js/Game'

new Game()